import { render, staticRenderFns } from "./Protocol.vue?vue&type=template&id=dbbeb53c&scoped=true"
import script from "./Protocol.vue?vue&type=script&lang=js"
export * from "./Protocol.vue?vue&type=script&lang=js"
import style0 from "./Protocol.vue?vue&type=style&index=0&id=dbbeb53c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbeb53c",
  null
  
)

export default component.exports